import { useContext, useMemo } from "react";
import { AuthContext } from "../providers/AuthValidationLayer";
import { menu } from "../constants/pages";

export const useFilteredMenu = () => {
  const { user, hasPermission } = useContext(AuthContext);

  const hasAnySupportAccess = () => {
    return (
      hasPermission("Support Center", "Complaints", "GET") ||
      hasPermission("Support Center", "FAQs", "GET") ||
      hasPermission("Support Center", "Knowledge Base", "GET") ||
      hasPermission("Support Center", "Training Videos", "GET")
    );
  };

  // Filter menu based on permissions
  const filteredMenu = useMemo(() => {
    return menu
      .map((item) => {
      switch (item.heading) {
        case "Dashboard":
          return item; // Always visible

        case "Support Center":
          return hasAnySupportAccess() ? item : null;

        case "Communication":
          return hasPermission("Communication", "Communication", "GET") ? item : null;
        
        case "Bookings":
           return hasPermission("General", "Bookings", "GET") ||
             hasPermission("General", "Bookings", "POST") ||
             hasPermission("General", "Bookings", "PATCH") ||
             hasPermission("General", "Bookings", "DELETE")
             ? item
             : null;
        
        case "Customer Management":
          {
            const filteredSubmenu = (item.submenu || []).filter((subItem) => {
              if (subItem.label === "Customer List") {
                return (
                  hasPermission("General", "Customer List", "GET") ||
                  hasPermission("General", "Customer List", "POST") ||
                  hasPermission("General", "Customer List", "PATCH") ||
                  hasPermission("General", "Customer List", "DELETE")
                );
              }

              if (subItem.label === "Booking History") {
                return (
                  hasPermission("General", "Booking History", "GET") ||
                  hasPermission("General", "Booking History", "POST") ||
                  hasPermission("General", "Booking History", "PATCH") ||
                  hasPermission("General", "Booking History", "DELETE")
                );
              }

              if (subItem.label === "Customer Policies") {
                return (
                  hasPermission("General", "Customer Policies", "GET") ||
                  hasPermission("General", "Customer Policies", "POST") ||
                  hasPermission("General", "Customer Policies", "PATCH") ||
                  hasPermission("General", "Customer Policies", "DELETE")
                );
              }

              return true;
            });

            return filteredSubmenu.length > 0
              ? { ...item, submenu: filteredSubmenu }
              : null;
          }
        
        case "Fleet Management":
          {
            const filteredSubmenu = (item.submenu || []).filter((subItem) => {
              if (subItem.label === "Vehicles") {
                return (
                  hasPermission("General", "Vehicles", "GET") ||
                  hasPermission("General", "Vehicles", "POST") ||
                  hasPermission("General", "Vehicles", "PATCH") ||
                  hasPermission("General", "Vehicles", "DELETE") ||
                  hasPermission("General", "Fleet Management", "GET") ||
                  hasPermission("General", "Fleet Management", "POST") ||
                  hasPermission("General", "Fleet Management", "PATCH") ||
                  hasPermission("General", "Fleet Management", "DELETE")
                );
              }

              if (subItem.label === "Drivers") {
                return (
                  hasPermission("General", "Drivers", "GET") ||
                  hasPermission("General", "Drivers", "POST") ||
                  hasPermission("General", "Drivers", "PATCH") ||
                  hasPermission("General", "Drivers", "DELETE") ||
                  hasPermission("General", "Fleet Management", "GET") ||
                  hasPermission("General", "Fleet Management", "POST") ||
                  hasPermission("General", "Fleet Management", "PATCH") ||
                  hasPermission("General", "Fleet Management", "DELETE")
                );
              }

              if (subItem.label === "Vendors") {
                return (
                  hasPermission("General", "Vendors", "GET") ||
                  hasPermission("General", "Vendors", "POST") ||
                  hasPermission("General", "Vendors", "PATCH") ||
                  hasPermission("General", "Vendors", "DELETE") ||
                  hasPermission("General", "Fleet Management", "GET") ||
                  hasPermission("General", "Fleet Management", "POST") ||
                  hasPermission("General", "Fleet Management", "PATCH") ||
                  hasPermission("General", "Fleet Management", "DELETE")
                );
              }

              return true;
            });

            return filteredSubmenu.length > 0
              ? { ...item, submenu: filteredSubmenu }
              : null;
          }
        
        case "Reports":
          {
            const filteredSubmenu = (item.submenu || []).filter((subItem) => {
              if (subItem.label === "Create Report") {
                return (
                  hasPermission("General", "Create Report", "GET") ||
                  hasPermission("General", "Create Report", "POST") ||
                  hasPermission("General", "Create Report", "PATCH") ||
                  hasPermission("General", "Create Report", "DELETE") ||
                  hasPermission("General", "Reports", "GET") ||
                  hasPermission("General", "Reports", "POST") ||
                  hasPermission("General", "Reports", "PATCH") ||
                  hasPermission("General", "Reports", "DELETE")
                );
              }

              if (subItem.label === "View Report") {
                return (
                  hasPermission("General", "View Report", "GET") ||
                  hasPermission("General", "View Report", "POST") ||
                  hasPermission("General", "View Report", "PATCH") ||
                  hasPermission("General", "View Report", "DELETE") ||
                  hasPermission("General", "Reports", "GET") ||
                  hasPermission("General", "Reports", "POST") ||
                  hasPermission("General", "Reports", "PATCH") ||
                  hasPermission("General", "Reports", "DELETE")
                );
              }

              if (subItem.label === "Stats") {
                return (
                  hasPermission("General", "Stats", "GET") ||
                  hasPermission("General", "Stats", "POST") ||
                  hasPermission("General", "Stats", "PATCH") ||
                  hasPermission("General", "Stats", "DELETE") ||
                  hasPermission("General", "Reports", "GET") ||
                  hasPermission("General", "Reports", "POST") ||
                  hasPermission("General", "Reports", "PATCH") ||
                  hasPermission("General", "Reports", "DELETE")
                );
              }

              return true;
            });

            return filteredSubmenu.length > 0
              ? { ...item, submenu: filteredSubmenu }
              : null;
          }
        
        case "Dispatch":
           return hasPermission("General", "Dispatch", "GET") ||
             hasPermission("General", "Dispatch", "POST") ||
             hasPermission("General", "Dispatch", "PATCH") ||
             hasPermission("General", "Dispatch", "DELETE") ||
             hasPermission("General", "Fleet Management", "GET") ||
             hasPermission("General", "Fleet Management", "POST") ||
             hasPermission("General", "Fleet Management", "PATCH") ||
             hasPermission("General", "Fleet Management", "DELETE")
             ? item
             : null;
        
        case "Operations Setup":
          {
            const filteredSubmenu = (item.submenu || []).filter((subItem) => {
              if (subItem.label === "Vehicle Segments") {
                return hasPermission("Operations Setup", "Vehicle Segments", "GET");
              }

              if (subItem.label === "Custom Booking") {
                return hasPermission("Operations Setup", "Custom Booking", "GET");
              }

              if (subItem.label === "Tour Package Management") {
                return hasPermission("Operations Setup", "Tour Package Management", "GET");
              }

              if (subItem.label === "State Tax List") {
                return hasPermission("Operations Setup", "State Tax List", "GET");
              }

              if (subItem.label === "Terms and Conditions") {
                return hasPermission("Operations Setup", "Terms and Conditions", "GET");
              }

              return true;
            });

            return filteredSubmenu.length > 0
              ? { ...item, submenu: filteredSubmenu }
              : null;
          }
        
        case "Access Control":
          return hasPermission("Access Control", "Roles", "GET") ||
            hasPermission("Access Control", "Employees", "GET") ||
            hasPermission("Access Control", "Audit Logs", "GET")
            ? item
            : null;
        
        case "Finance":
          {
            const filteredSubmenu = (item.submenu || []).filter((subItem) => {
              if (subItem.label === "Customer") {
                return (
                  hasPermission("General", "Finance Customer", "GET") ||
                  hasPermission("General", "Finance Customer", "POST") ||
                  hasPermission("General", "Finance Customer", "PATCH") ||
                  hasPermission("General", "Finance Customer", "DELETE") ||
                  hasPermission("General", "Finance", "GET") ||
                  hasPermission("General", "Finance", "POST") ||
                  hasPermission("General", "Finance", "PATCH") ||
                  hasPermission("General", "Finance", "DELETE")
                );
              }

              if (subItem.label === "Driver") {
                return (
                  hasPermission("General", "Finance Driver", "GET") ||
                  hasPermission("General", "Finance Driver", "POST") ||
                  hasPermission("General", "Finance Driver", "PATCH") ||
                  hasPermission("General", "Finance Driver", "DELETE") ||
                  hasPermission("General", "Finance", "GET") ||
                  hasPermission("General", "Finance", "POST") ||
                  hasPermission("General", "Finance", "PATCH") ||
                  hasPermission("General", "Finance", "DELETE")
                );
              }

              if (subItem.label === "Vendor") {
                return (
                  hasPermission("General", "Finance Vendor", "GET") ||
                  hasPermission("General", "Finance Vendor", "POST") ||
                  hasPermission("General", "Finance Vendor", "PATCH") ||
                  hasPermission("General", "Finance Vendor", "DELETE") ||
                  hasPermission("General", "Finance", "GET") ||
                  hasPermission("General", "Finance", "POST") ||
                  hasPermission("General", "Finance", "PATCH") ||
                  hasPermission("General", "Finance", "DELETE")
                );
              }

              if (subItem.label === "Generate Invoice and Receipts") {
                return (
                  hasPermission("General", "Generate Invoice and Receipts", "GET") ||
                  hasPermission("General", "Generate Invoice and Receipts", "POST") ||
                  hasPermission("General", "Generate Invoice and Receipts", "PATCH") ||
                  hasPermission("General", "Generate Invoice and Receipts", "DELETE") ||
                  hasPermission("General", "Finance", "GET") ||
                  hasPermission("General", "Finance", "POST") ||
                  hasPermission("General", "Finance", "PATCH") ||
                  hasPermission("General", "Finance", "DELETE")
                );
              }

              return true;
            });

            return filteredSubmenu.length > 0
              ? { ...item, submenu: filteredSubmenu }
              : null;
          }
        
        case "Verification Center":
          {
            const filteredSubmenu = (item.submenu || []).filter((subItem) => {
              if (subItem.label === "Driver Approvals") {
                return hasPermission("Verification Center", "Driver Approvals", "GET");
              }
              if (subItem.label === "Vehicle Approvals") {
                return hasPermission("Verification Center", "Vehicle Approvals", "GET");
              }
              if (subItem.label === "Vendor Approvals") {
                return hasPermission("Verification Center", "Vendor Approvals", "GET");
              }
              if (subItem.label === "Awaiting Clarification") {
                return hasPermission("Verification Center", "Awaiting Clarification", "GET");
              }
              if (subItem.label === "Vendor Onboarding Config") {
                return hasPermission("Verification Center", "Vendor Onboarding Config", "GET");
              }
              return true;
            });

            return filteredSubmenu.length > 0
              ? { ...item, submenu: filteredSubmenu }
              : null;
          }
        
        case "System Logs":
          return hasPermission("System Logs", "System Logs", "GET") ? item : null;
        
        default:
          return null;
      }
    })
    .filter(Boolean);
  }, [user, hasPermission]);

  return filteredMenu;
};
